import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ArticlesComponent } from './articles/articles.component';
import { ViewArticleComponent } from './view-article/view-article.component';
import { NavHeaderComponent } from './nav-header/nav-header.component';
import { SplashScreenComponent } from './splash-screen/splash-screen.component';
import {CardModule} from "primeng/card";
import {AngularSvgIconModule} from "angular-svg-icon";
import {PaginatorModule} from "primeng/paginator";
import {HttpClientModule} from "@angular/common/http";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {DividerModule} from "primeng/divider";
import {MenuModule} from "primeng/menu";
import {ButtonModule} from "primeng/button";
import { PrivacyComponent } from './privacy/privacy.component';
import {EllipsisModule} from "ngx-ellipsis";

@NgModule({
  declarations: [
    AppComponent,
    ArticlesComponent,
    ViewArticleComponent,
    NavHeaderComponent,
    SplashScreenComponent,
    PrivacyComponent
  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        ProgressSpinnerModule,
        CardModule,
        AngularSvgIconModule.forRoot(),
        PaginatorModule,
        DividerModule,
        MenuModule,
        ButtonModule,
        EllipsisModule,
    ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
